// ! This file was auto-generated from the managed-entities OpenAPI schema. Do not override this file.
export const Tags = {
    Entity_Aliases: "Entity Aliases",
    Entity_Field_Values: "Entity Field Values",
    Entity_Type_Fields: "Entity Type Fields",
    Entity_Types: "Entity Types",
    EntityAlias: "EntityAlias",
    EntityFieldValue: "EntityFieldValue",
    EntityType: "EntityType",
    EntityTypeField: "EntityTypeField",
    Group: "Group",
    Groups: "Groups",
    Healthchecks: "Healthchecks",
    Node: "Node",
    Nodes: "Nodes"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
